<template>
  <dashboard-page
    title="Tipos de requerimento"
    subtitle="Lista de tipos de requerimentos ativos"
  >
    <template #actions>
      <router-link
        v-if="issuesTypesAdd"
        :to="{
          path: '/configurations/issuesTypes/add'
        }"
      >
        <base-button size="sm" type="neutral">Novo</base-button>
      </router-link>
    </template>
    <div class="content">
    <b-container fluid>
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <div>
            <b-col
              cols="12"
              class="d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Buscar..."
                >
                </base-input>
              </div>
            </b-col>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column
                v-if="issuesTypesEdit || issuesTypesDelete"
                min-width="130px"
                align="right"
                label="Ações"
              >
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    v-if="issuesTypesEdit"
                    @click="handleEdit(row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni ni-ruler-pencil"></i>
                  </base-button>
                  <base-button
                    v-if="issuesTypesDelete"
                    @click="handleDelete(row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni ni-fat-remove"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Mostrando {{ from + 1 }} a {{ to }} de {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} linhas selecionadas
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </b-container>
  </div>
  </dashboard-page>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters } from "vuex";
import bocapioService from "./../../services/nodejs/index";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      tableColumns: [
        {
          type: "selection"
        },
        {
          prop: "date",
          label: "Data",
          formatter: (row, col, cell, index) =>
            this.formatDataLocaleString(cell),
          minWidth: 130,
          sortable: true
        },
        {
          prop: "label",
          label: "Tipo",
          minWidth: 140,
          sortable: true
        }
      ],
      issuesTypesAdd: null,
      issuesTypesEdit: null,
      issuesTypesDelete: null,
      tableData: [],
      selectedRows: []
    };
  },
  computed: {
    ...mapGetters([
      "roles"
      // ...
    ])
  },
  mounted() {
    this.roles.configurations ? this.getConfigurationsRoles() : "";
    this.getTiposRequerimentosAtivos();
  },
  methods: {
    getTiposRequerimentosAtivos() {
      bocapioService
        .getTiposRequerimentosAtivos()
        .then(rsp => {
          console.log("resposta getTiposRequerimentosAtivos ", rsp.data);
          this.tableData = rsp.data;
          this.createFuseSearch(["date", "label"]);
        })
        .catch(error => {
          console.log("catch getRequerimentosByUserId ", error);
        });
    },

    deleteTipoRequerimento(row) {
      bocapioService
        .deleteTipoRequerimento(row.id)
        .then(rsp => {
          console.log("resposta deleteTipoRequerimento ", rsp.data);
          this.showSwal(
            "Sucesso!!",
            "Item deletado com sucesso !!",
            "primary",
            "success"
          );
          this.deleteRow(row);
        })
        .catch(error => {
          this.$router.push("/issuesTypes");
          this.showSwal(
            "Erro!!",
            "Algo deu errado. Tente novamente mais tarde !!",
            "warning",
            "warning"
          );
        });
    },

    paginationChanged(page) {
      this.pagination.currentPage = page;
    },

    handleEdit(row) {
      console.log("row", row);
      this.$router.push({
        name: "Editar Tipo",
        params: { issuesTypes: row } // data[1] is id in table
      });
    },

    handleDelete(row) {
      console.log("row", row);
      swal
        .fire({
          title: `Tem certeza?`,
          text: "Este item será deletado permanentemente ...",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-default",
          icon: "question"
        })
        .then(result => {
          if (result.isConfirmed) {
            this.deleteTipoRequerimento(row);
          }
        });
    },

    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    showSwal(title, text, btn, icon) {
      swal.fire({
        title: title,
        text: text,
        buttonsStyling: false,
        confirmButtonClass: `btn btn-${btn}`,
        icon: icon
      });
    },
    getConfigurationsRoles() {
      this.issuesTypesAdd = this.roles.configurations.find(
        role =>
          role.controller === "configurations" &&
          role.action === "issuesTypes/add"
      );
      this.issuesTypesEdit = this.roles.configurations.find(
        role =>
          role.controller === "configurations" &&
          role.action === "issuesTypes/edit"
      );
      this.issuesTypesDelete = this.roles.configurations.find(
        role =>
          role.controller === "configurations" &&
          role.action === "issuesTypes/delete"
      );
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
